module.exports = __webpack_public_path__ + "img/mode3.7df2348a.png";